import { decryptData } from "./cryptographicOperations"
import axios from "axios"

const hostURL = process.env.REACT_APP_API_URL

const getUrlUserInfo = () => {
	const searchParams = new URLSearchParams(window.location.search)
	const user =
		searchParams.get("rr") &&
		JSON.parse(decryptData(decodeURIComponent(searchParams.get("rr"))))
	return user
}

const getUserHealth = async () => {
	try {
		const url = `${hostURL}/api`
		const response = await axios.get(url)
		// console.log("getUserHealth response ", response)
		return response
	} catch (error) {
		console.error("error", error)
		return error
	}
}

export { getUrlUserInfo, getUserHealth }
